export default __webpack_public_path__ + "static/media/documentary.e0f990e8.png";